import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from "@tanstack/react-query";
import { api } from "@/api/client";
import type {
  DataResponse,
  HranaPravidlo,
  HranaPravidloCreate,
} from "@/api/schemas";

const KEY = ["hrana-pravidla"] as const;

export function useHranovePravidla(): UseQueryResult<
  DataResponse<HranaPravidlo[]>
> {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => {
      const { data } = await api.get<DataResponse<HranaPravidlo[]>>(
        "/hrana-pravidla",
      );
      return data;
    },
    staleTime: 60_000,
  });
}

export function useCreateHranovePravidlo(): UseMutationResult<
  DataResponse<HranaPravidlo>,
  Error,
  HranaPravidloCreate
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post<DataResponse<HranaPravidlo>>(
        "/hrana-pravidla",
        payload,
      );
      return data;
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteHranovePravidlo(): UseMutationResult<
  void,
  Error,
  string
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/hrana-pravidla/${id}`);
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: KEY }),
  });
}
